import { render, staticRenderFns } from "./FailedLogin.vue?vue&type=template&id=bb4d0bb0&scoped=true"
import script from "./FailedLogin.vue?vue&type=script&lang=js"
export * from "./FailedLogin.vue?vue&type=script&lang=js"
import style0 from "./FailedLogin.vue?vue&type=style&index=0&id=bb4d0bb0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb4d0bb0",
  null
  
)

export default component.exports